/* eslint-disable */

export const HTTPS_PATTERN = /^((http|https):\/\/s3)/;
export const PASSWORD_PATTERN = /^(?=.*[a-zA-Z])(?=.*\d)[\S]+$/;
export const EMAIL_PATTERN = /^[a-zA-Z0-9.+\-#$%&‘*—/=?^_`{|}~]{1,64}@[a-zA-Z0-9.-]{1,64}$/;
export const NO_ESCAPE = /[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;
export const LINK_PATTERN = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
